<ng-container *ngFor="let filter of filtersConfig">
  <div class="filters-row" *ngIf="!filter.hidden">
    <div class="filters-row__label">
      {{ filter.label }}
    </div>
    <ng-container [ngSwitch]="filter.type">
      <cm-checkbox-group
        *ngSwitchCase="FILTER_TYPES.checkboxGroup"
        [ngModel]="filtersValue[filter.name]"
        (ngModelChange)="onFilterChange(filter.name, $event)"
        [disabled]="filter.disabled"
        [options]="filter.options">
      </cm-checkbox-group>
      <cm-range
        *ngSwitchCase="FILTER_TYPES.range"
        [disabled]="filter.disabled"
        [ngModel]="filtersValue[filter.name]"
        (ngModelChange)="onFilterChange(filter.name, $event)">
      </cm-range>
      <cm-date-range
        *ngSwitchCase="FILTER_TYPES.dateRange"
        [disabled]="filter.disabled"
        [ngModel]="filtersValue[filter.name]"
        (ngModelChange)="onFilterChange(filter.name, $event)"
        [minDate]="filter.minDate"
        [maxDate]="filter.maxDate">
      </cm-date-range>
      <cm-select
        *ngSwitchCase="FILTER_TYPES.select"
        [placeholder]="filter.placeholder"
        [disabled]="filter.disabled"
        [ngModel]="filtersValue[filter.name]"
        (ngModelChange)="onFilterChange(filter.name, $event)"
        [options]="filter.options">
      </cm-select>
      <cm-multi-select
        *ngSwitchCase="FILTER_TYPES.multiselect"
        [placeholder]="filter.placeholder"
        [disabled]="filter.disabled"
        [ngModel]="filtersValue[filter.name]"
        (ngModelChange)="onFilterChange(filter.name, $event)"
        [options]="filter.options"
        [params]="filter.params"
        [request$]="filter.request$"
        [valueType]="filter.valueType">
      </cm-multi-select>
      <cm-typeahead
        *ngSwitchCase="FILTER_TYPES.typeahead"
        [placeholder]="filter.placeholder"
        [disabled]="filter.disabled"
        [formatter]="filter.formatter"
        [request$]="filter.request$"
        [tooltip]="filter.tooltip"
        [ngModel]="filtersValue[filter.name]"
        (ngModelChange)="onFilterChange(filter.name, $event)">
      </cm-typeahead>
      <cm-custom-control *ngSwitchCase="FILTER_TYPES.custom" [template]="filter.template"></cm-custom-control>
    </ng-container>
  </div>
</ng-container>
